<script>
import Icon from './icon';
import EventBus from '../instances/event-bus';
import $ from 'jquery';
import Slick from 'slick-carousel';

export default {
  components: {
    Icon
  },
  data () {
    return {
    }
  },
  props: {
    appendArrows: ""
  },
  mounted() {
    this.$slick =     $(this.$slots.slides[0].elm).slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      appendArrows: this.$refs.arrows,
      prevArrow: this.$refs.prev,
      nextArrow: this.$refs.next,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    const width = $(window).width();
    if (width >= 768) {
      this.$slick.slick('slickSetOption', 'slidesToScroll', 3, true);
    } else if (width >= 400) {
      this.$slick.slick('slickSetOption', 'slidesToScroll', 2, true);
    }

  }
}
</script>

<template lang="html">
  <div>
    <slot name="slides"></slot>
    <div class="l-padding">
      <div class="l-wrap--wide">
        <div ref="arrows" class="Slider-arrows">
          <button class="Slider-arrow prev" ref="prev">
            <icon icon="texture-arrow"></icon>
            <span class="u-screenreader">Previous</span>
          </button>
          <button class="Slider-arrow next" ref="next">
            <icon icon="texture-arrow"></icon>
            <span class="u-screenreader">Next</span>
          </button>
        </div>
        <div class="Slider-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// slider.vue?dc49452c